import CarbonClient from "../CarbonClient";

//GET Requests
export const getFlowGuidesByViewName = async (viewName: string) => {
  const response = await CarbonClient.get(`api/FlowGuide/${viewName}`);
  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status };
  }
};

export const updateFlowGuideSeenStatus = async (flowGuideId: string) => {
  const response = await CarbonClient.put(`api/FlowGuide/UpdateSeenStatus/${flowGuideId}`);
  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status };
  }
};
